import { render, staticRenderFns } from "./LifetimePlansSection.vue?vue&type=template&id=6fea1d98&scoped=true"
import script from "./LifetimePlansSection.vue?vue&type=script&lang=js"
export * from "./LifetimePlansSection.vue?vue&type=script&lang=js"
import style0 from "./LifetimePlansSection.vue?vue&type=style&index=0&id=6fea1d98&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fea1d98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fea1d98')) {
      api.createRecord('6fea1d98', component.options)
    } else {
      api.reload('6fea1d98', component.options)
    }
    module.hot.accept("./LifetimePlansSection.vue?vue&type=template&id=6fea1d98&scoped=true", function () {
      api.rerender('6fea1d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/Plans/LifetimePlansSection.vue"
export default component.exports